import './Filter.scss';
import React, { useState } from 'react';
import {
    // GET_ALL_LOFAS,
    GET_ALL_DRIVERS_FILTER,
    GET_ALL_CARRIERS_FILTER,
    // GET_ALL_PROPPANTS,
    GET_JOB_FILTERS_LIST,
    GET_ALL_JOBS_FILTER,
    GET_ALL_STATUS_FILTER,
    GET_ALL_REGIONS,
    GET_ALL_TRAILER_TYPES,
    GET_ALL_EQUIPMENT_TYPES,
    GET_ALL_ASSET_LOAD_TYPES,
    // GET_ALL_TRAILER_TYPES_FILTER,
    // GET_ALL_EQUIPMENT_TYPES_FILTER,
    // GET_ALL_LOAD_TYPES_FILTER,
    GET_ALL_LOFAS,
    GET_ALL_PROPPANTS,
    // GET_ALL_LOAD_STATUS_TYPES
    GET_ALL_ASSET_LOAD_STATUS_TYPES
} from '../../graphql/client/queries';
import { useStoreContext } from '../App/StoreProvider';
import LoadFilterItem from './FilterItem/LoadFilterItem';
import AssetLoadFilterItem from './FilterItem/AssetLoadFilterItem';
import Button from 'react-bootstrap/Button';
import { useQuery } from '@apollo/client/react';
import {
    GetAllDriversFilter,
    GetAllCarriersFilter,
    GetAllTrailerTypes,
    GetAllEquipmentTypes,
    GetAllAssetLoadTypes,
    GetAllJobsFilter,
    GetAllAssetLoadStatusTypes,
    GetAllRegions,
} from '../../types/schemaTypes';
import DatePickerFilterItem from './DatePickerFilterItem/DatePickerFilterItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface LoadFiltersProps {
    abortRequest: () => void;
    onFilterToggle: () => void;
    showFilter: boolean;
    setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AssetLoadFilters = ({
    abortRequest,
    onFilterToggle,
    showFilter,
    setShowFilter,
}: LoadFiltersProps): React.ReactElement => {
    const [activeKey, setActiveKey] = useState('0');
    const [state] = useStoreContext();

    // const { data: lofasData } = useQuery(GET_ALL_LOFAS);
    const { data: driversData } = useQuery<GetAllDriversFilter>(GET_ALL_DRIVERS_FILTER);
    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);
    // const { data: proppantsData } = useQuery(GET_ALL_PROPPANTS);
    // const { data: jobFiltersData } = useQuery(GET_JOB_FILTERS_LIST);
    const { data: jobData } = useQuery<GetAllJobsFilter>(GET_ALL_JOBS_FILTER);
    const { data: loadStatusesData } = useQuery<GetAllAssetLoadStatusTypes>(GET_ALL_ASSET_LOAD_STATUS_TYPES);
    const { data: regionsData } = useQuery<GetAllRegions>(GET_ALL_REGIONS);
    const { data: trailerTypeData } = useQuery<GetAllTrailerTypes>(GET_ALL_TRAILER_TYPES);
    const { data: equipmentTypeData } = useQuery<GetAllEquipmentTypes>(GET_ALL_EQUIPMENT_TYPES);
    const { data: loadTypeData } = useQuery<GetAllAssetLoadTypes>(GET_ALL_ASSET_LOAD_TYPES);

    // let jobStatuses: any = [];
    // const proppants: any = [];
    // const lofaFilters: any = [];
    let driverFilters: any = [];
    let carrierFilters: any = [];
    let loadStatuses: any = [];
    // const districtFilters: any = [];
    const regionFilters: any = [];
    // let customerFilters: any = [];
    let allJobsFilters: any = [];
    let trailerTypeFilters :any =[];
    let equipmentTypeFilters :any =[];
    let loadTypeFilters :any =[];

    const {
        assetLoadManagementList: {
            searchPhraseSubset: {
                jobSubset,
                regionSubset,
                trailerTypeSubset,
                equipmentTypeSubset,
                loadTypeSubset,
                carrierSubset,
                statusSubset,
                // proppantSubset,
                // lofaSubset,
                driverSubset,
            },
            filters: { fromDate, toDate, equipmentId },
        },
    } = state;

    // if (lofasData && lofasData.getAllLofas) {
    //     lofasData.getAllLofas.forEach((item: any) => {
    //         lofaFilters.push({
    //             id: item.lofaId,
    //             name: item.lofaName,
    //         });
    //     });
    // }

    if (driversData && driversData.getAllDriversFilter) {
        driverFilters = driversData.getAllDriversFilter;
    }

    if (carriersData && carriersData.getAllCarriersFilter) {
        carrierFilters = carriersData.getAllCarriersFilter;
    }

    if(trailerTypeData && trailerTypeData.getAllTrailerTypes) {
        trailerTypeFilters = trailerTypeData.getAllTrailerTypes;
    }

    if(equipmentTypeData && equipmentTypeData.getAllEquipmentTypes) {
        equipmentTypeFilters = equipmentTypeData.getAllEquipmentTypes;
    }

    if(loadTypeData && loadTypeData.getAllAssetLoadTypes) {
        loadTypeFilters = loadTypeData.getAllAssetLoadTypes;
    }

    // if (proppantsData && proppantsData.getAllProppants) {
    //     proppantsData.getAllProppants.forEach((item: any) => {
    //         proppants.push({
    //             id: item.proppantId,
    //             name: item.proppantName,
    //         });
    //     });
    // }

    // if (jobFiltersData && jobFiltersData.getJobFiltersList) {
    //     if (jobFiltersData.getJobFiltersList.statuses) {
    //         jobStatuses = jobFiltersData.getJobFiltersList.statuses;
    //     }
    //     if (jobFiltersData.getJobFiltersList.customers) {
    //         customerFilters = jobFiltersData.getJobFiltersList.customers;
    //     }
    // }

    if (jobData && jobData.getAllJobsFilter) {
        allJobsFilters = jobData.getAllJobsFilter;
    }

    if (loadStatusesData && loadStatusesData.getAllAssetLoadStatusTypes) {
        
        loadStatuses = [...loadStatusesData.getAllAssetLoadStatusTypes];
        
        // Remove the UNKNOWN status from the statuses list
        loadStatuses = loadStatuses.filter((stat: any) => {
            return stat?.name !== 'Unknown';
        });
        const copyLoadStatus : any = [];
        loadStatuses.forEach((ele)=>{
            const copy = {...ele};
            // if (copy?.name == 'Created'){
            //     copy.name = 'Created/Rejected'; 
            // }
            copyLoadStatus.push(copy);
        });
        loadStatuses = copyLoadStatus;
    }

    if (regionsData && regionsData.getAllRegions) {
        regionsData.getAllRegions.forEach((item: any) => {
            regionFilters.push({
                id: item.id,
                name: item.regionName,
            });

            // item.districts.forEach((district: any) => {
            //     districtFilters.push({
            //         id: district.id,
            //         name: district.districtName,
            //     });
            // });
        });
    }

    /*
    Equipment ID
    Region
    Job Name
    Load Status
    Trailer Type
    Equipment Type
    Load Type
    Delivered Date
    Driver
    Carrier
    */

    return (
        <div
            id="MessagesFilterContainer"
            className={showFilter ? 'JobLoads-FiltersContainer' : 'JobLoads-FiltersContainer hide'}
        >
            <div className="Filter-Container">
                <div className="Filter-Header">
                    <div className="Filter-HeaderIconContainer">
                        <i className="material-icons">filter_list</i>
                        <span className="Filter-HeaderTitle">Filters</span>
                    </div>
                    <Button
                        className="Filter-SelectAll"
                        variant="link"
                        onClick={(): void => setActiveKey(activeKey === '0' ? '1' : '0')}
                    >
                        {activeKey === '0' ? 'Collapse All' : 'Expand All'}
                    </Button>
                    <FontAwesomeIcon
                        icon={['fas', 'times-circle']}
                        className="JobLoads-Filter"
                        onClick={() => setShowFilter(!showFilter)}
                    />
                </div>
                <div className="Filter-Body">
                <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        isOnlySearchAble={true}
                        title="Equipment Id"
                        items={[]}
                        itemsSubset={[]}
                        searchPhrase={""}
                        activeKey={activeKey}
                        // isCollection={true}
                        isSearchable={true}
                        // loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />

                <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Region"
                        items={regionFilters}
                        itemsSubset={regionSubset.subset}
                        searchPhrase={regionSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    
                    <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Job Name"
                        items={allJobsFilters}
                        itemsSubset={jobSubset.subset}
                        searchPhrase={jobSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Load Status"
                        items={loadStatuses}
                        itemsSubset={statusSubset.subset}
                        searchPhrase={statusSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={false}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    {/* <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Customer"
                        items={customerFilters}
                        itemsSubset={customerSubset.subset}
                        searchPhrase={customerSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    /> */}
                    
                    <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Trailer Type"
                        items={trailerTypeFilters}
                        itemsSubset={trailerTypeSubset.subset}
                        searchPhrase={trailerTypeSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Equipment Type"
                        items={equipmentTypeFilters}
                        itemsSubset={equipmentTypeSubset.subset}
                        searchPhrase={equipmentTypeSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={false}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Load Type"
                        items={loadTypeFilters}
                        itemsSubset={loadTypeSubset.subset}
                        searchPhrase={loadTypeSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <DatePickerFilterItem
                        abortRequest={abortRequest}
                        title="Delivered Date"
                        activeKey={activeKey}
                        fromDate={fromDate}
                        toDate={toDate}
                        filterType="Load"
                        closeDateRange={() => {}}
                    />
                    
                    
                    {/* <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Proppant"
                        items={proppants}
                        itemsSubset={proppantSubset.subset}
                        searchPhrase={proppantSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    /> */}
                    <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Driver"
                        items={driverFilters}
                        itemsSubset={driverSubset.subset}
                        searchPhrase={driverSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <AssetLoadFilterItem
                        abortRequest={abortRequest}
                        title="Carrier"
                        items={carrierFilters}
                        itemsSubset={carrierSubset.subset}
                        searchPhrase={carrierSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                </div>
            </div>
        </div>
    );
};
